module.exports = __webpack_public_path__ + "static/media/DKTN.8be46e92.svg";